var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.912,
    height: 10.912,
    viewBox: "0 0 10.912 10.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M5.456,0a5.456,5.456,0,1,0,5.456,5.456A5.456,5.456,0,0,0,5.456,0Zm0,10A4.547,4.547,0,1,1,10,5.456,4.547,4.547,0,0,1,5.456,10Z",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M10.909,10h-.455a.455.455,0,0,0,0,.909h.455v2.728a.455.455,0,0,0,.909,0V10.909A.909.909,0,0,0,10.909,10Z",
    transform: "translate(-5.453 -5.453)",
    fill: "#bbc6d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(4.774 2.273)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrInfo);
export default __webpack_public_path__ + "static/media/fi-rr-info.f30b7701.svg";
export { ForwardRef as ReactComponent };